



























































































































import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import request from '@/utils/request'
import sha1 from 'sha1'
import wx from 'weixin-js-sdk'
import { WECHAT_APPID } from '@/utils/constants'
import ImContentLeft from './im_content_left.vue'
import ImContentRight from './im_content_right.vue'
import { number } from 'echarts'
const storagePrefix = 'cz.tobacco.h5.'
export default Vue.extend({
    components: {
        ImContentLeft,
        ImContentRight,
    },
    data() {
        return {
            opposite: {} as any,

            liveChatId: '',
            title: '',
            loading: false,
            pageNum: 0,
            pageSize: 15,
            total: 0,
            chatListDefault: [],
            chatList: [],
            currentToken: this.$store.state.token,
            inputText: '',
            imgShow: false,
            imgUrl: '',
            imgcheck: false,
            imgcheckUrl: '',
            imgchatMode: 0,
            cameraShow: false,
            mediaStreamTrack: {},
            video_stream: '', // 视频stream
            imgSrc: '', // 拍照图片
            canvas: null,
            context: null,
            isSounds: false,
            btnView: false,
            wxConfiged: false, // 微信是否已配置
            isRecording: false, // 是否正在录音
            // isRecording: true, // 是否正在录音
            startTime: 0, // 录音开始时间
            soundsId: '',
            touchstartTime: 0,
            touchendTime: 0,
            targetInfo:{},
            creatorInfo:{},
            recordTag: '',
            mainNum: 0,
        }
    },
    computed: {
        current(): any {
            return this.$store.state.current
        },
        managerInfo(): any {
            return this.$store.state.managerInfo
        },
        isExpert(): boolean {
            return true
        },
    },
    created() {
        this.initWeixin()
        // console.log('----------------------------')
        // console.log(this.$route.params.id)
        // console.log(this.$route.query)
        this.liveChatId = this.$route.params.id === 'null' ?  '' : this.$route.params.id
        if (!this.liveChatId) {
          this.title = this.$route.query.name
        }
        this.onInit()
        // this.getOpposite()
    },
    methods: {
        scroll() {
            const scrollTop = this.$refs.box.scrollTop;
            if (scrollTop === 0 && this.chatList.length < this.total) {
                this.loading = true
                this.onLoad()
            }
        },
        onInit() {
            this.pageNum = 1
            this.getData()
        },
        onLoad() {
            this.pageNum += 1
            this.getData()
        },
        async getData() {
            const { liveChatId, pageNum, pageSize } = this
            const params = { pageNum, pageSize, liveChatId }as any
            if (!liveChatId) {
                params.toId = this.$route.query.relationId
                params.fromId = this.current.id
            }
            await request.get('/api/chat/rest_chat/chat/record', params).then(({creatorInfo,targetInfo,chatPage})=> {
                const {list, total} = chatPage
                if (creatorInfo.id === this.current.id) {
                    this.targetInfo = targetInfo
                    this.creatorInfo = creatorInfo
                } else {
                    if (creatorInfo.id === this.managerInfo?.id) {
                    this.targetInfo = targetInfo
                    this.creatorInfo = creatorInfo
                    } else {
                    this.targetInfo = creatorInfo
                    this.creatorInfo = targetInfo
                    }
                }
                this.title = this.targetInfo.realName? this.targetInfo.realName:this.targetInfo.nickname?this.targetInfo.nickname:'未知'
                list.map((e) => {
                    // console.log(JSON.parse(JSON.stringify(e)))
                    if (e.chatMode === 4) {
                        // console.log(JSON.parse((e.content)))
                        const content = JSON.parse((e.content))
                        // e.soundsTime = content.time < 60 ? content.time + 's' : Math.floor(content.time / 60) + 'm' +  content.time % 60 + 's'
                        e.soundsTime = content.time +'s'
                        e.soundsStr = content.filePath
                    }
                })
                // if(pageNum==1) this.chatListDefault = list.reverse()
                // else this.chatListDefault = list.reverse().concat(this.chatListDefault)
                if(pageNum==1) this.chatListDefault = list
                else this.chatListDefault = list.concat(this.chatListDefault)
                // console.log(this.chatListDefault)
                const defaultData = JSON.parse(JSON.stringify(this.chatListDefault))
                // console.log(defaultData)
                defaultData.map((e) => {
                    e.timeShow = true
                    e.timestr = Number(moment(e.createTime).format('YYYYMMDDHHmm'))
                })
                if(defaultData.length > 1) {
                    defaultData.map((e, i) => {
                        if(i < defaultData.length - 1) {
                            if(defaultData[i].timestr === defaultData[i + 1].timestr) {
                                defaultData[i + 1].timeShow = false
                            } else {
                                defaultData[i + 1].timeShow = true
                            }
                        } else {
                            // console.log('last one')
                            if(defaultData[defaultData.length - 2].timestr === defaultData[defaultData.length - 1].timestr) {
                                defaultData[defaultData.length - 1].timeShow = false
                            } else {
                                defaultData[defaultData.length - 1].timeShow = true
                            }
                        }
                    })
                }
                // console.log(defaultData)
                defaultData.map((e) => {
                    e.location = 'left'
                    if (e.fromId === this.current.id) {
                        e.location = 'right'
                    } else {
                        if (e.fromId === this.managerInfo?.id) {
                            e.location = 'right'
                        }
                    }
                    // console.log(JSON.parse(JSON.stringify(e)))
                })
                this.chatList = defaultData
                this.total = total
                // 滚动到地图显示区域
                this.$nextTick(() => {
                    const box: any = this.$refs.box
                    const boxClientHeight = box.clientHeight;
                    const main: any = document.getElementById('main')
                    const mainHeight: any = getComputedStyle(main, 'false').height
                    const mainNum: any = mainHeight.split('p')[0].split('.')[0]
                    if (pageNum == 1) {
                        this.mainNum = Number(mainNum)
                        box.scrollTop = mainNum - boxClientHeight
                    } else {
                        box.scrollTop = mainNum - this.mainNum - 30
                        this.mainNum = Number(mainNum)
                    }
                })
                setTimeout(()=>this.loading = false, 100)
            })
        },
        sendParams(chatMode, content) {
            const { role } = this.current
            let expertId = '' //  默认fromId取当前账户ID，当前账户为专家时，应为专家ID
            if( role == 1)  {
                expertId = this.managerInfo?.id
            }
            let toId = ''
            let fromId = ''
            if (this.liveChatId) {
                const creatorInfo = this.creatorInfo
                const targetInfo = this.targetInfo
                toId = targetInfo.id
                fromId = creatorInfo.id
            } else {
                toId = this.$route.query.relationId
                fromId = this.current.id
            }
            //  默认发送消息到toID，toID为对方的ID，当对方有关联ID时，将关联的relationID传到后台用于推送消息
            const params = {
                toId,
                fromId,
                liveChatId: this.liveChatId,
                fromRole: role, expertId, relationId: this.opposite?.relationId
            }as any
            params.chatMode = chatMode
            params.content = content
            // console.log(params)
            request.post('/api/chat/rest_chat', params)
            // request.post('/chat/rest_chat', params)
            .then((res)=>{
                this.liveChatId = res
                this.onInit()
                this.inputText = ''
                this.btnView = false
            })
            .catch(e => this.$notify(e))
        },
        // 发送文字、图片消息
        send() {
            let chatMode = 0
            let content = ''
            if (this.inputText) {
                chatMode = 1
                content = this.inputText
            // } else if (this.imgSrc) {
            //     chatMode = 5
            //     content = this.imgSrc
            } else {
                const arr = ['jpg','jpeg','png']
                const str = this.imgUrl.split('.')[1]
                if (arr.indexOf(str) > -1) {
                    chatMode = 2
                } else if (str === 'mp4' || str === 'MOV') {
                    chatMode = 3
                } else {
                    chatMode = 6
                }
                content = this.imgUrl
            }
            this.sendParams(chatMode, content)
        },
        // 选择相册图片消息
        handleSuccess(response: any) {
            // console.log(response)
            this.imgShow = true
            this.imgUrl = response
            this.$Message.success('上传完成')
        },
        handleError(res: any) {
            console.log(res)
            this.$Message.error('上传失败，请重试')
        },
        handleFormatError(file: any) {
            this.$Notice.warning({
                title: '文件格式有误',
                desc: '文件' + file.name + '格式有误, 文档请选择jpg,jpeg,png或mp4格式文件',
            });
        },
        handleRemove() {
            console.log('删除')
        },
        submit(data) {
            this.imgShow = false
            this.cameraShow = false
            if (data) {
                this.send()
            }
            this.imgUrl = ''
            this.imgSrc = ''
        },
        checkImg(data) {
            // this.imgcheck = true
            // this.imgcheckUrl = data.content
            // this.imgchatMode = data.chatMode
            const current = 'https://ylwx.sxktqx.com/chat_files' + data.content
            wx.previewImage({
                current: current,
                urls: [current],
                success: (res: any) => {
                    // alert(res)
                },
                fail: (err: any) => {
                    alert(JSON.stringify(err))
                },
            })
        },
        // 选择拍照图片消息
        captureImage() {
            // 适用手机
            // const a = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAtCAYAAAAgJgIUAAAI3UlEQVRYR62YC3BV1RWGv7XPvTc3CfJQQEFeYu2ooFa0Op1qH8D0gWN1KlBrCxiQRsUXFErCox7RECLhqaIhkCBK0VCfbdFq0TrT2s602plia2dU3gMKQsIjj3tyz1mdfRLh5t6bcKPumUxmkrX3/vda//rXWkf4nEsn1DlccXwkgZkIugeNvizzJx34PMfJ59mkrhshb8i3EClB9SpUmjA8C94KKSne090zuw1C6+ocdjSOQ7UC5KuA035pI6ovEQTzZMFtu7sDpFsgQg9Eh4zBmBWgFwLp+xtRWY/GFsv8Wz7JFUjOIEIOXNk4mkBXgWQD0Han6hFEVpPwHhO3+NNcgOQEIgQwqvFaRCpQ/XoWD6TfdRBYkyuQ3ECU1YzCyFLg2ykcOM0j9RDIIzR4q6Wi+GhXxqcFoe7G/sQCF7QIIZ6Le0/aqO6F4B68fS+L6wad7e0ShLq1cfK4FXgA6N8tAG38CEBexph7pWRKp6nbNYgltZegVANXdcED7ZIjSgMilUTMSpkzuTHbQzoFoe5jPcgr+CVgf87ouFmTKIcR+RRlH6IDQc4C6QOan3aRIvIOgU6SeUX/yxmE2vxftP5SImYDwmUdXio0EOgbQC1BsJ2kkyDuxfAj5yPmJoQfAwPSLjsK8iB5R9bIrFnN6UCyekKXbiwk6c8C5qR4wWL7GNFHkeRG/vnaAUaMEAqH5/FBs8fa4iTlm3ojyevQ4NfA+YBpv9CG7C2gSEqLduUGomL9QAKzGbg2xQuHgQoSVItb1KCVv+lLonk0Ri4gYDdx3uLvr+xn7FjDYec6xFkFDD61X23oZuP12CzuRC8VSHZPLK65GpEt7YeEPAfeRLwiW6C0rGoAEitFGA8UAgmUvxL45SyY9g/KH++NxstBppxMa8VDeBqaZ0vpnfVdglC3LkasaRLowwhntkkxLYiuo6F1Afm0khebAcwFzko5rAXkaVRK8HYeJzZ0CrDk5BltD3kP9EYpnbqjaxBLqnqh0QdAfgG0M13q0cDFk7VEI30wSRsqq57paxfIeCm99R1dvOGbiD4LnJtidBDlDr5S+JJMnOh/9veMcGhZ9dkYpxbk+6eIpZ8ici8tu+uIDxiIxv4I2CKWlrn6CSI3S2nRn3VxzcWIvAIMSVHQE6FmJJqWiTvjROcgKqoHoZGXUEal3HAMDcrxkqspzO9B0q8BxmWIlLIL9DpKi96nfMMPEa0BOTvlnCaEJ8BbJCWn6kmmJ8prhoO8DgxP2eyBPkckch+N/jFiTAJKERkMGgGsPB8B/S0Jfz5HjzVzdp+ZaMibnh14E7AB0zwvlZyZIBZVX0HUeRFkUMpmS6r9wEzeLXyeEYfyiRWMBZ2GcDGK7aS2oPHnmffTgzy0djhO9ClErk7RCnucTc1nUTNT5k2xKR+uDiBCpSyrHYthI3BOWsQDlG34zGDBrR+yZYvhg6N9MZF8Ai9Ba6xe3KIWXVzTD2QW6F2I9Oh4hli5fxGCO2Xe1EOdcyJkdVAHMjCTeGGqvgCyFtX/cCTSxFXxFv5bnwdOnJg5xxITuB3om6Ww2bA+gzqzOvVEKAkP1l5AhNeAYVlS0Ga7FZ2Pgb+h/Bvhg3bbixG+hoZynVbw2k9SPYHKCloLHxZ3YhfZ8VDNYAxbERmZFcSpfEuGrb6QAGLtmmJ/d7UsD2ZzprdJiotbOw/Hw7Xn4MtToGNy6CVPc2eGkOxHmCAlU99O/U9mdrjrziTPsf3kz9tf2M2LujLXD0n635OF03d2DWJuVS96RRchchtQ8CUisHx6l0BvlAVT93YKQl3XEB30XYx5AsSK1Wf9wJeERfehcjf/2vo72bIle+3QsicvxdH1qFrJtkZWDU/bkXcDoQ/6JiKzpKRoewYxteypAZhkOXALqglEbLm94FQl7cZV2U2ttAegraCbMHo/c6cdENDwlbp8eT4tvYrBLEQoRPV1jNmLcjNony98PZJEdCfKMdCRIE0olRxxVknl5EYJpbpi44UEYWW8GuQjCO5ApSfCY1nku/uYwrafRxAOo5S0n/k2vn+LneBFK9afQeDcAzoXtTzQZXjNK9F4T+LyKMg3svDCFjRLWquMdiqz09WRdh6lcSg03Q7JX+FHDxIJVqPyI1A7Gs6m8Phm0QerzyMatWS0ndJfSHpTZWHxR2Gm5A0dgpiLCDSKSismsDOEQ6CKaK+27kuuAT2Mqi3tBwiMhHaB74S2xigq+9l/7D3OusQnuvNmjCxvC7O8QODdK1q+/iYwq0BtwXmShMy13fRnPg/DNWGCYcR38qEgArtP4Lo+ZdX9cSJPoFyPsoeoM4bZk3bxwJpC4hGHllgCdnvcf7+K2Ki3LS2vHYbyHMLlKDswwU2i5TXLIRQmu5YScZanj2va1nfehcpgjL7AjtY3GBbtjYgdEa8H21ExBvHq0eidqAyA4E94Z7ya3t6rW9WXWKwK4QbAzjHTRBfXPt0+NTWhOgdvzyZx3Q5zgT60biiO82pYLW0/4Hl3EzUOJroOdBwiu1Edje9raKf0R1jZ6YOCmItQDBy3XbsF8QcE2yXVE/iTZP5029p1WCFvIhE7+g0FthIkp9Ea+OTF1gDjsb2lMJpkUtrt+hFQSWtTZWpDG4Zj5vJ8+va+HREXQ0CgK0TLa+14dg3wEcnkDbJw+vtZQTiRbYgFob8nEplO444GYoN+gpj5CNtpScwgL16A8gZov2xddQhiwgSHy8aNw9E1qBQg+rjlRCXIDxCpQ/wVMneadVGmJ9JAyJzJB8P0bo1cRDS5j+a9H+OcOxRr1wWIEIj98JKXvA+kFyZYLWpLd9zvgUTqswEIN7Wl8TZUrSe2Evi3yfzpGV/nTtoFQT9Ul9HakhGO8DybcUuqeqI9DKU/a8ipOIVpBduA80BfRClObVQ7pF+bne01K3DMss4+jKS6OjcQbR30akSvBLOGRKJK3OKmjLAt3difpL8WuAiRMloKnklP0WyanxsIS6ZR4waH4fAS7+PecchWvwwQ4TB94nKM9Cdp3mXBlP3Z7NL3/R/xxbaU/xz/jgAAAABJRU5ErkJggg=='
            // const file = this.base64ToFile(a, "headImage.jpg");
            // this.uploadImage(file);
            this.getImage()
            // this.cameraShow = true
            // 适用电脑
            // setTimeout(() => {
            //     this.getCamera()
            // }, 1000);
        },
        getImage() {
            const that = this
            wx.chooseImage({
                count: 1, // 默认9
                sizeType: ["compressed"], // 可以指定是原图还是压缩图，默认二者都有（我使用的压缩图）
                sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
                success: function (res) {
                    let file = res.localIds[0];
                    wx.getLocalImgData({ // 使用这个方法将chooseImage返回的临时路径转换为base64编码
                        localId: file.toString(),
                        success: function (res) {
                            const localData = res.localData;
                            let imageBase64 = "";
                            if (localData.indexOf("data:image") == 0) {
                                //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                                imageBase64 = localData;
                            } else {
                                //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                                //此时一个正常的base64图片路径就完美生成赋值到img的src中了
                                imageBase64 = "data:image/jpeg;base64," + localData.replace(/\n/g, "");
                            }
                            // // that.sendParams(5, imageBase64)
                            const file = that.base64ToFile(imageBase64, "headImage.jpg"); // 在将base64编码转换成file文件即可上传
                            that.uploadImage(file);
                        },
                    });
                },
                fail: function (res) {
                    console.log("失败");
                    console.log(res);
                }
            });
        },
        uploadImage(file: any) {
            // console.log(file)
            // const imageBase64 = 'data:image/png;base64,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'
            // const file = this.base64ToFile(imageBase64, "headImage.jpg"); // 在将base64编码转换成file文件即可上传
            const formdata = new FormData()
            formdata.append('file', file)
            formdata.append('filePath', 'chat')
            axios({
                url: '/api/chat/rest_file/upload',
                method: 'post',
                data: formdata,
                headers: {'content-type': 'application/json;charset=UTF-8', Authorization: this.currentToken},

            }).then((res) => {
                console.log(res)
                this.sendParams(2, res.data)
            })
        },
        base64ToFile(base64, fileName) {
            // base64转file文件
            let arr = base64.split(",");
            let mime = arr[0].match(/:(.*?);/)[1];
            let bytes = atob(arr[1]);
            let n = bytes.length;
            let ia = new Uint8Array(n);
            while (n--) {
                ia[n] = bytes.charCodeAt(n);
            }
            return new File([ia], fileName, { type: mime });
        },
        getCamera() {
            this.canvas = document.getElementById("canvasCamera");
            this.context = this.canvas.getContext("2d");
            if (navigator.mediaDevices === undefined) { return }
            navigator.mediaDevices.getUserMedia({
                audio: true,
                video: true,
                // video: { facingMode: "user" },
                // video: { facingMode: { exact: "environment" } },
            }).then((stream: any) => {
                this.mediaStreamTrack = typeof stream.stop === "function" ? stream : stream.getTracks()[0];
                this.video_stream = stream;
                this.$refs.video.srcObject = stream;
                this.$refs.video.play();
            }).catch((err) => {
                console.log(err);
            });
        },
        setImage() {
            // 点击canvas画图
            this.context.drawImage(this.$refs.video, 0, 0, 200, 100);
            // console.log("拍照", this.context.drawImage);
            // 获取图片base64链接 canvas
            this.canvas = document.getElementById("canvasCamera");
            this.canvas.style.display = "block";
            // console.log(this.canvas, "拍照 image ", this.canvas.style);
            const image = this.canvas.toDataURL("image/png");
            this.imgSrc = image;
            // console.log(this.imgSrc, "拍照 image ", image);
            // console.log(this.imgSrc);
        },
        // 关闭摄像头
        CloseCamera() {
            console.log('关闭摄像头');
            this.$refs.video.srcObject.getTracks()[0].stop();
            this.cameraShow = false
        },
        getSoundsId(id) {
            this.soundsId = id
        },
        onTouchstart(event: Event) {
            this.touchstartTime = 0
            this.touchendTime = 0
            event.stopPropagation()
            event.preventDefault()
            this.soundsId = ''
            this.touchstartTime = new Date().getTime()
            // this.isRecord('start')
            wx.startRecord({
                success: () => {
                    this.startTime = new Date().getTime()
                    this.isRecording = true
                    if (this.touchstartTime !== 0 && this.touchendTime !== 0 && (this.touchendTime - this.touchstartTime) < 800) {
                        this.isRecording = false
                        wx.stopRecord()
                    }
                },
                fail: (err) => {
                    alert(JSON.stringify(err))
                },
            })
        },
        onTouchmove(event) {
            // console.log('touchmove')
            // 按钮所在位置：距两边50px，距底部130px，按钮宽高90
            const innerWidth = event.view.innerWidth
            const innerHeight = event.view.innerHeight
            const clientX = event.changedTouches[0].clientX
            const clientY = event.changedTouches[0].clientY
            if (clientY < innerHeight - 130 && clientY > innerHeight - 130 - 90 ) {
                if (clientX > 50 && clientX < 50 + 90) {
                    console.log('zuo')
                    this.recordTag = 'cancel'
                } else if (clientX > innerWidth - (50 + 90) && clientX < innerWidth - 50) {
                    console.log('you') 
                    this.recordTag = 'submit'
                } else {
                    this.recordTag = ''
                }
            } else {
                this.recordTag = ''
            }
        },
        onTouchend() {
            this.touchendTime = new Date().getTime()
            // this.isRecord('end')
            if (this.touchendTime - this.touchstartTime < 800) {
                this.$notify('间隔太短')
                if (this.isRecording === true) {
                    this.isRecording = false
                    wx.stopRecord()
                }
            } else {
                if (!this.isRecording) return
                if (new Date().getTime() - this.startTime < 800) {
                    this.$notify('间隔太短')
                    this.isRecording = false
                    wx.stopRecord()
                } else {
                    if (this.recordTag === '' || this.recordTag === 'submit') {
                        wx.stopRecord({ 
                            success: this.stopRecord, 
                            fail: (res: any) => {
                                console.error(JSON.stringify(res))
                                alert(JSON.stringify(res))
                            }
                        })
                    } else if (this.recordTag === 'cancel') {
                        this.isRecording = false
                        wx.stopRecord()
                    }
                }
            }
        },
        isRecord(tag) {
            if (this.touchstartTime && this.touchendTime) {
                if (this.touchendTime - this.touchstartTime < 800) {
                    this.$notify('间隔太短')
                    this.touchstartTime = 0
                    this.touchendTime = 0
                    this.isRecording = false
                    wx.stopRecord()
                } else {
                    if (tag === 'end') {
                        if (!this.isRecording) return
                        if (new Date().getTime() - this.startTime < 800) {
                            console.log('间隔太短')
                            this.$notify('间隔太短')
                            this.touchstartTime = 0
                            this.touchendTime = 0
                            this.isRecording = false
                            wx.stopRecord()
                        } else {
                            if (this.recordTag === '' || this.recordTag === 'submit') {
                                wx.stopRecord({ 
                                    success: this.stopRecord, 
                                    fail: (res: any) => {
                                        console.error(JSON.stringify(res))
                                        alert(JSON.stringify(res))
                                    }
                                })
                            } else if (this.recordTag === 'cancel') {
                                this.touchstartTime = 0
                                this.touchendTime = 0
                                this.isRecording = false
                                wx.stopRecord()
                            }
                        }
                    }
                }
            }
        },
        async stopRecord(res: any) {
            console.log('stopRecord')
            this.isRecording = false
            // 上传到微信服务器
            wx.uploadVoice({
                localId: res.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success: (serverRes: any) => {
                    var { serverId } = serverRes // 返回音频的服务器端ID
                    request.post(`/api/chat/wechat_audio?serverId=${serverId}`).then((filePath: any) => {
                        const time = Math.round((new Date().getTime() - this.startTime)/ 100) / 10
                        const recordData = {
                            time: String(time).indexOf('.') > -1 ? time.toFixed(1) : time,
                            serverId,
                            filePath,
                        }
                        // console.log(recordData)
                        // 上传到自己服务器
                        this.sendParams(4, JSON.stringify(recordData))
                    })
                },
                error:(err: any) => {
                    console.log(err)
                }
            })
        },
        async initWeixin() {
            this.wxConfiged = true
            const timestamp = moment().valueOf()
            const nonceStr = 'cztobaccoh5'
            const jsapiTicket = await request.get('/api/account/office_account/jsapi_ticket')
            console.log('jsapiTicket', jsapiTicket)
            const params = `jsapi_ticket=${jsapiTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${window.location.href}`
            console.log('params', params)
            const signature = sha1(params)
            wx.ready(() => {
                this.wxConfiged = true
                wx.onVoiceRecordEnd({ complete: this.stopRecord })
            })
            wx.config({
                debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                appId: WECHAT_APPID, // 必填，公众号的唯一标识
                timestamp, // 必填，生成签名的时间戳
                nonceStr, // 必填，生成签名的随机串
                signature,// 必填，签名
                jsApiList: ['startRecord', 'stopRecord', 'onVoiceRecordEnd', 'uploadVoice', 'downloadVoice', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'chooseImage', 'getLocalImgData', 'previewImage'] // 必填，需要使用的 JS 接口列表
            })
        },
        async getOpposite() {
            // console.log(this.isExpert)
            // oppositeId: '', // 目标ID，即专家ID
            if(this.isExpert) {
                request.get(`/api/account/rest_account/${this.oppositeId}`).then((acco: any) => {
                    this.title = acco.realName
                    this.opposite = acco
                })
            } else {
                let relationData = {}as any
                await request.get(`/api/tobacco/manager/info/${this.oppositeId}`).then((res: any)=> {
                    // console.log(res)
                    relationData = res
                    // this.opposite = res
                    // this.title = res.name
                })
                // console.log(relationData)

                const currentId = this.current.id

                if(currentId === relationData.relationId){
                    this.isExpert = true
                }
                this.opposite = relationData
                this.title = relationData.name
                // if(!this.headimgurl) {
                //     // console.log(this.opposite.relationId)
                //     const obj = await this.getExpertImg(relationData, relationData.relationId)
                //     this.$set(this.opposite, 'headimgurl', obj)

                // }
            }
        },
        getExpertImg(expertChat, relationId) {
            let headimgurl = ''
            return request.get(`/api/account/rest_account/${relationId}`).then(res => {
                if (res) {
                    headimgurl = res.headimgurl
                } else {
                    if (expertChat.sex === 1) {
                        headimgurl = '/static/images/sex_1.png'
                    } else if (expertChat.sex === 2) {
                        headimgurl = '/static/images/sex_2.png'
                    } else {
                        headimgurl = '/static/images/sex_0.png'
                    }
                }
                if(headimgurl ===''){
                  headimgurl = '/static/images/sex_0.png'
                }
                return headimgurl
            })
        },
    },
    filters: {
        dtFormat(timestamp: number) {
            const time = moment(timestamp)
            if(isToday(time)) {
                return time.format('HH:mm')
            }
            return time.format('YYYY年M月D日 HH:mm')
        }
    },
})
function isToday(momentDate: moment.Moment) {
    return momentDate.isSame(moment().startOf('day'), 'd')
}
